<template>
  <div class="fc-content text-break">
    <div v-if="agendaEvent.showAsPrivateOccupiedSlot === true">
      <div>
        <i class="fa fa-clock-o pr-1"/>
        {{ $options.filters.localTime(event.start, 'HH:mm')}} - {{ $options.filters.localTime(event.end, 'HH:mm')}}
      </div>
    </div>
    <va-popover
      v-else-if="agendaEvent.bookingType"
      :message="$t(`activities_agenda.agenda.booking_types.${agendaEvent.bookingType.slug}`)"
      placement="top"
      :popoverStyles = "popoverStyles"
      :backgroundColor="agendaEvent.bookingType.color ? agendaEvent.bookingType.color : '#29c4a9'"
    >
      <AgendaEventDisplay :event="agendaEvent" :view="view"/>
    </va-popover>


  </div>
</template>

<script>
import AgendaEventDisplay from "@/components/activities_agenda/agenda/AgendaEventDisplay.vue";

const DEFAULT_COLOR = '#29c4a9'
export default {
  components: {
    AgendaEventDisplay
  },
  props: {
    view: {
      type: Object,
      required: true
    },
    event: {
      type: Object,
      required: true
    }
  },
  mounted: function () {
  },
  computed: {
    agendaEvent: function() {
      return {
        ...this.event.extendedProps,
        start: this.event.start,
        end: this.event.end
      }
    },
    getAppointmentTypeLabel: function () {
      if (!this.appointment.type) return null
      let label = this.appointment.type.name
      if (this.appointment.type.slug && label !== this.appointment.type.slug) {
        label += ` (${this.appointment.type.slug})`
      }
      return label
    },
    popoverBackgroundColor: function () {
      return this.event.bookingType && this.event.bookingType.color ? this.event.bookingType.color : DEFAULT_COLOR
    },
    popoverStyles: function () {
      return {
        color: 'white',
        'font-size': '0.8rem',
        'background-color': this.popoverBackgroundColor
      }
    }
  }
};
</script>

<style scoped>

</style>
